/**
 * RESPONSIBILITY: draw the original band — a picture and its words, the side set by position.
 *
 * THE MARKUP HERE IS THE MARKUP THIS PAGE HAS ALWAYS HAD, character for character. It is
 * the default template and what every band saved before templates existed means, so a
 * change to it is a change to every ministry page on the site. Do not tidy it. First band
 * picture-left, next picture-right, and so on, so an editor changes the rhythm by dragging
 * a row. A band with no picture is the full width, because half a band of whitespace beside
 * text reads as a picture that failed to load.
 */
import { Html } from '@framework/react';
import { Picture } from '../../commons/Picture';
import type { BandDef, BandProps } from '../../commons/bands';

function Draw({ b: band, tinted }: BandProps) {
  const words = <Html className="md-body lede ministry-wide">{band.bodyHtml}</Html>;

  if (!band.image?.path) {
    return (
      <section className={tinted ? 'band band-tint' : 'band'}>
        <div className="wrap">{words}</div>
      </section>
    );
  }

  const picture = (
    <div className="ministry-pic-container">
      <Picture
        value={band.image} alt={band.image.alt}
        className="block-pic ministry-section-pic"
      />
    </div>
  );

  return (
    <section className={tinted ? 'band band-tint ministry-section-band' : 'band ministry-section-band'}>
      <div className="wrap split ministry-split-wrap">
        {tinted ? picture : <div className="stack ministry-text-stack">{words}</div>}
        {tinted ? <div className="stack ministry-text-stack">{words}</div> : picture}
      </div>
    </section>
  );
}

export const alternating: BandDef = {
  has: (b) => !!(b.bodyHtml || b.image?.path),
  Draw,
};
